import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  hexToRgba,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const BecomeADealer = () => (
  <Section
    css={`
      margin-bottom: 0px;
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query BecomeADealerBecomeADealerHeroImageQuery {
          file(relativePath: { eq: "savantPowerVan.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 40% 50%;
              @media screen and (min-width: ${getSize(
                  "tablet720"
                )}) and (max-width: 959px) {
                object-position: 32% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        background-color: ${({
          theme: {
            colors: { mayAsWellBeWhite },
          },
        }) => mayAsWellBeWhite};
        @media screen and (min-width: ${getSize("mobile480")}) {
          padding: 32px 50px 34px 50px;
        }

        @media screen and (min-width: ${getSize("tablet720")}) {
          background-color: ${({
            theme: {
              colors: { offWhite },
            },
          }) => hexToRgba(offWhite, 0.9)};
        }

        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 1199px) {
          width: 377px;
        }

        @media screen and (min-width: ${getSize(
            "tablet768"
          )}) and (max-width: 959px) {
          padding: 42px 46px 48px 50px;
        }

        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 28px 40px 34px 40px;
        }

        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          width: 452px;
        }

        @media screen and (min-width: ${getSize("desktop1920")}) {
          margin-top: -28px;
          padding: 70px 80px 73px 80px;
          width: 552px;
        }
      `}
    >
      <Header2>
        {"Become a Dealer"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize("desktop1920")}) {
              margin-top: 21px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (max-width: ${getSize("mobile480")}) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 21px;
          }
        `}
      >
        {
          "Savant Power provides nationwide sales and service for premium whole-home and commercial, smart battery energy storage systems along with solar solutions, for projects of all sizes."
        }
      </Paragraph>
    </Card>
  </Section>
);
